import { render, staticRenderFns } from "./BirthDateInput.vue?vue&type=template&id=1c8e13d6&scoped=true&"
import script from "./BirthDateInput.vue?vue&type=script&lang=js&"
export * from "./BirthDateInput.vue?vue&type=script&lang=js&"
import style0 from "./BirthDateInput.vue?vue&type=style&index=0&id=1c8e13d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8e13d6",
  null
  
)

export default component.exports